import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { SystemDTO } from '../../models/system-dto';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-system-detail-page',
  standalone: true,
  imports: [CommonModule, ModuleContainerDirective],
  templateUrl: './system-detail-page.component.html',
  styleUrl: './system-detail-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemDetailPageComponent {
  @Input({ required: true }) public slug!: string;
  private readonly route = inject(ActivatedRoute);
  public readonly data$: Observable<SystemDTO> = this.route.data.pipe(
    map(d => d['data'] as SystemDTO),
  );
}
